import React, { Component } from 'react'
import Title from './Title'
import Loading from './Loading'

export default class HoursAndLocationInfo extends Component {
    render() {
        return (

            <section className="hoursInfoContainer">
                <div className="hoursAndLocation">
                    <Title title='Hours & Location' />
                    <p>607 Richmond St, London, ON N6A 3G3 (519).642.2558</p>
                    <h6>lunch special</h6>
                    <p>monday - saturday 12:00pm - 4:00pm</p>
                    <h6>dinner</h6>
                    <p>monday - thursday 12:00pm - 9:00pm</p>
                    <p>friday, saturday 12:00pm - 9:30pm</p>
                    <p>sunday 12:00pm - 8:30pm</p>
                </div>

                <div className="reservationPolicy">
                    <Title title='Reservation Policy' />
                    <p>Your table will be held for 15 minutes after your reservation time.</p>
                    <p>We set aside some seating for walk-ins.</p>
                    <p>Please note that there is a 2.5 hour seating time limit for parties of 7 and more.</p>
                </div>
            </section>

        )
    }

}
